const imageGallery = document.querySelectorAll('[data-slider="image-gallery"]');

if (imageGallery.length > 0) {
  const baseImageGalleryOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    watchOverflow: true,
    pagination: {
      clickable: true,
    },
    navigation: {},
  };

  // Initialize ONE gallery only
  const initImageGallerySlider = (el) => {
    const parentEle = el.closest('[data-slider-parent]');
    const arrowLeft = parentEle.querySelector('.swiper-button-prev');
    const arrowRight = parentEle.querySelector('.swiper-button-next');
    const sliderPagination = parentEle.querySelector('.swiper-pagination');

    const options = {
      ...baseImageGalleryOptions,
      navigation: {
        prevEl: arrowLeft,
        nextEl: arrowRight,
      },
      pagination: {
        ...baseImageGalleryOptions.pagination,
        el: sliderPagination,
      },
    };

    new Swiper(el, options);
  };

  setupResponsiveSliders({
    sliderElements: imageGallery,
    breakpoint: 767,
    initSlider: initImageGallerySlider,
    mobileFallback: enableArrowScrollSync,
    parentSelector: '[data-slider-parent]',
  });
}
